class VideoPlayer {
  constructor($el) {
    this.$el = $el;
    this.isShowControl = false;
    this.hasVideoElement = false;
    this.src = '';

    // console.log('show-control', this.$el.attr('data-show-control'));

    // console.log('VideoPlayer', this.$el);
    if(this.$el.find('video')) {
      this.hasVideoElement = true;
      // console.log('mp4ファイルが存在します');
      this.video = this.$el.find('video').get(0);
      // this.video.playsInline = true;
      // this.video.muted = true;
      this.src = this.$el.find('video').attr('src');


      if(this.$el.attr('data-show-control') != undefined) {
        this.isShowControl = true;

        this.$btnPlay = this.$el.find('.BtnMoviePlay');
        this.$btnPlay.on('click', () => {
          this.play();

          /*
          if(this.isShowControl) this.$btnPlay.css('display', 'none');
          this.video.currentTime = 0;
          this.video.play();
          console.log('ビデオ再生開始 - クリックイベント内');
          */
        });

        // console.log(this.video);
        this.video.addEventListener('ended', () => {
          // console.log('ビデオ再生完了を検出', this.src);
          this.pause();
          // document.getElementById("kanryou").innerHTML = "動画の再生が完了しました。";
        }, false);
      }





    } else {
      console.log('mp4ファイルが存在しません');
    }
  }

  play() {
    if(this.isShowControl) this.$btnPlay.css('display', 'none');
    if(this.hasVideoElement) {
      this.video.currentTime = 0;
      this.video.play();
      // console.log('ビデオ再生開始');
    }
  }


  pause() {
    if(this.isShowControl) this.$btnPlay.css('display', 'flex');
    if(this.video != undefined) {
      this.video.pause();
      this.video.currentTime = 0;
      // console.log('ビデオ再生完了');
    }
  }
}

export default VideoPlayer;
